var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12" }, [
          _c("div", { staticClass: "form-field" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      readonly: "",
                      id: "filtroPersona",
                      placeholder: "Seleccione una persona..."
                    },
                    model: {
                      value: _vm.nombrePersona,
                      callback: function($$v) {
                        _vm.nombrePersona = $$v
                      },
                      expression: "nombrePersona"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        Persona\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.id_persona === "",
                        expression: "form.id_persona === ''"
                      }
                    ],
                    staticClass: "btn-info",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.$modal.show("consultaPersonas")
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-search" })]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.id_persona !== "",
                        expression: "form.id_persona !== ''"
                      }
                    ],
                    staticClass: "btn-danger",
                    attrs: { type: "button" },
                    on: { click: _vm.quitarPersona }
                  },
                  [_c("i", { staticClass: "fa fa-ban" })]
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("k-table", {
        ref: "tablaComprobantes",
        attrs: {
          buttons: [
            {
              text: "",
              class: "btn-info",
              icon: "fa-eye",
              event: "ver"
            }
          ],
          fechas: "",
          buscarNumero: "",
          tipoComprobante: _vm.tipoComprobante,
          createButton: false,
          editButton: false,
          deleteButton: false,
          path: _vm.path,
          params: _vm.form,
          columns: [
            {
              display: "Fecha de emisión",
              value: "fecha_emision"
            },
            {
              display: "N° establecimiento",
              value: "numero_establecimiento"
            },
            {
              display: "N° emisor",
              value: "punto_emision"
            },
            {
              display: "N° Secuencial",
              value: "numero_documento"
            },
            {
              display: "Proveedor",
              value: "razon_social"
            },
            {
              display: "N° Identificación del proveedor",
              value: "ruc"
            },
            {
              display: "Total sin impuestos",
              value: "total_sin_impuestos",
              numeric: true,
              hidden: _vm.tipoComprobante === "07"
            },
            {
              display: "IVA",
              value: "valor_iva",
              numeric: true,
              hidden: _vm.tipoComprobante === "07"
            },
            {
              display: "ICE",
              value: "valor_ice",
              numeric: true,
              hidden: _vm.tipoComprobante === "07"
            },
            {
              display: "IRBPNR",
              value: "valor_irbpnr",
              numeric: true,
              hidden: _vm.tipoComprobante === "07"
            },
            {
              display: "Total",
              value: "total",
              numeric: true
            },
            {
              display: "Estado",
              value: "descripcion_estado"
            }
          ]
        },
        on: { ver: _vm.ver, seleccionar: _vm.seleccionar }
      }),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "55%",
            height: "auto",
            name: "consultaPersonas",
            scrollable: ""
          }
        },
        [
          _c("lista-personas", {
            attrs: {
              createButton: false,
              tipoFiltro: _vm.tipoComprobante === "07" ? "C" : "P",
              filterStatus: false
            },
            on: { selected: _vm.selectedPersona }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("h3", [_vm._v("Comprobantes")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ada10c2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ada10c2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/compras/ListaComprobantesCompra.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2ada10c2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/compras/ListaComprobantesCompra.vue
// module chunks = 0